import { StyledButton } from 'components/button';
import { TextButton } from 'components/ui/text-button';
import { rem } from 'polished';
import styled, { Theme } from 'styled-components';

export const Form = styled.form`
  max-width: ${rem(460)};
  margin: 0 auto;

  ${StyledButton}, ${TextButton} {
    display: flex;
    width: 100%;
    max-width: ${rem(250)};
    margin: 0 auto;
    margin-top: ${rem(10)};
  }

  ${TextButton} {
    display: block;
    margin: ${rem(30)} auto;
  }

  a:not(${StyledButton}) {
    color: inherit;
  }

  p {
    margin: ${rem(32)} 0;
  }
`;

export const FormWrapper = styled.div`
  margin: ${rem(32)} 0;
  padding: ${rem(32)};
  color: ${({ theme }) => theme.colors.palette.black};
  background-color: ${({ theme }) => theme.colors.palette.white};
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${rem(62)};
  }
`;

export const PasswordInfo = styled.div<GlobalErrorProps>`
  margin-top: ${rem(8)};
  color: ${({ theme, color }) =>
    color ? theme.colors.palette[color] : theme.colors.palette.black};
  font-size: ${rem(14)};
  line-height: 1.4;
  text-align: left;
`;

interface GlobalErrorProps {
  color?: keyof Theme['colors']['palette'];
}

export const GlobalError = styled.div<GlobalErrorProps>`
  color: ${({ theme, color }) =>
    color ? theme.colors.palette[color] : theme.colors.palette.redDark};
  font-weight: bold;
  text-align: left;

  &:not(:empty) {
    margin-bottom: ${rem(20)};
  }
`;

export const IntroWrapper = styled.div`
  max-width: ${rem(360)};
  margin: 0 auto;
`;
